import { SequenceMenu } from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'
import { useNavigate } from 'react-router-dom'

export const ViewInvoice = (props: { invoiceId: string }) => {
  const navigate = useNavigate()
  const { can } = usePermissions()

  if (can('org.invoice:update')) {
    return null
  }

  return (
    <SequenceMenu.Item
      data-testid="invoices.viewInvoice.menuItem"
      uuid="view-invoice"
      label="View invoice"
      onClick={() => {
        navigate(`/invoices/${props.invoiceId}`)
      }}
    />
  )
}
